import { render } from "./WelcomeView.vue?vue&type=template&id=2703e54a"
import script from "./WelcomeView.vue?vue&type=script&lang=js"
export * from "./WelcomeView.vue?vue&type=script&lang=js"

import "./WelcomeView.vue?vue&type=style&index=0&id=2703e54a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__